export enum HeaderActionType {
    Home = 'Home',
    Menu = 'Menu',
    Return = 'Return',
    Close = 'Close',
    NoAction = 'NoAction',
}
